import styled, { css } from 'styled-components'
import { isMobileStyleMixin } from '@amzn/storm-ui'
export type MediaSize = 'mini' | 'small' | 'medium' | 'large'

//https://quip-amazon.com/prH7AZCsibJm/FIT-Image-Sizing-Guidance
const imageSizes = {
  mini: { width: 300, height: 225 },
  small: { width: 320, height: 240 },
  medium: { width: 330, height: 330 },
  large: { width: 440, height: 330 },
}

export const ImageContainer = styled.div<{ size: MediaSize; mobilePadding?: number; hasContent?: boolean }>`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-content: stretch;
  align-items: center;
  box-sizing: content-box;
  padding: 10px;
  ${({ hasContent }) =>
    hasContent
      ? css`
          margin-bottom: ${({ theme }) => theme.spacing.medium};
        `
      : ``}
  background-color: ${({ theme }) => theme.palette.white};
  border: 1px solid ${({ theme }) => theme.palette.ccxEmptyGrey};
  box-shadow: ${({ theme }) => theme.card.boxShadow};
  border-radius: 6px;
  height: ${({ size }) => imageSizes[size].height}px;
  width: ${({ size }) => imageSizes[size].width}px;
  ${({ mobilePadding }) =>
    mobilePadding
      ? isMobileStyleMixin(css`
          width: calc(100% - ${mobilePadding}px);
          height: auto;
        `)
      : isMobileStyleMixin(css`
          width: calc(100% - 22px);
          height: auto;
        `)}

  & img {
    height: ${({ size }) => imageSizes[size].height}px;
    width: ${({ size }) => imageSizes[size].width}px;
    border: 1px solid ${({ theme }) => theme.palette.ccxBorderGrey};
    border-radius: ${({ theme }) => theme.card.radius};
    ${isMobileStyleMixin(css`
      width: 100%;
      height: auto;
    `)}
  }
`
